"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPartnerHostedLivestreamContainerProperty = exports.partnerHostedLivestreamContainerPropertyDefinition = void 0;
exports.partnerHostedLivestreamContainerPropertyDefinition = {
    view: { label: 'Livestream Partners' },
    constraints: [
        {
            name: 'properties',
            argument: ['partner-hosted-livestream'],
        },
    ],
    type: 'container',
    multiple: true,
    name: 'partner-hosted-livestream-container',
};
const isPartnerHostedLivestreamContainerProperty = (prop) => {
    return prop.name === exports.partnerHostedLivestreamContainerPropertyDefinition.name;
};
exports.isPartnerHostedLivestreamContainerProperty = isPartnerHostedLivestreamContainerProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGFydG5lci1ob3N0ZWQtbGl2ZXN0cmVhbS1jb250YWluZXIucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy9wYXJ0bmVyLWhvc3RlZC1saXZlc3RyZWFtLWNvbnRhaW5lci5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLGtEQUFrRCxHQUFHO0lBQ2hFLElBQUksRUFBRSxFQUFFLEtBQUssRUFBRSxxQkFBcUIsRUFBRTtJQUN0QyxXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxZQUFZO1lBQ2xCLFFBQVEsRUFBRSxDQUFDLDJCQUEyQixDQUFDO1NBQ3hDO0tBQ0Y7SUFDRCxJQUFJLEVBQUUsV0FBVztJQUNqQixRQUFRLEVBQUUsSUFBSTtJQUNkLElBQUksRUFBRSxxQ0FBcUM7Q0FDWixDQUFBO0FBSTFCLE1BQU0sMENBQTBDLEdBQUcsQ0FBQyxJQUFrQixFQUFvRCxFQUFFO0lBQ2pJLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSywwREFBa0QsQ0FBQyxJQUFJLENBQUE7QUFDOUUsQ0FBQyxDQUFBO0FBRlksUUFBQSwwQ0FBMEMsOENBRXREIn0=